import { render, staticRenderFns } from "./CoreErrorAlerts.vue?vue&type=template&id=65d072a8"
import script from "./CoreErrorAlerts.vue?vue&type=script&lang=js"
export * from "./CoreErrorAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports